RivalIQ.apps.Reports.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            widgetId: widgetTypes.REPORT_PICKER,
            props: {
                reportType: 'channel'
            }
        },
        {
            widgetId: widgetTypes.REPORT_PICKER,
            props: {
                reportType: 'cross_channel'
            }
        },
        {
            widgetId: widgetTypes.REPORT_PICKER,
            props: {
                reportType: 'csv_public'
            }
        },
        {
            widgetId: widgetTypes.REPORT_PICKER,
            props: {
                reportType: 'csv_private'
            }
        }
    ];

    const WidgetsView = RivalIQ.apps.Dashboard.views.CurationWidgets.extend({
        showActions: function () {
            const me = this;
            me.actions.show(new RivalIQ.views.Link({
                className: 'btn-link',
                linkName: [
                    $.tagHtml('span', {
                        text: 'Edit Theme'
                    }),
                    $.tagHtml('span', {
                        class: ['fa', 'fa-chevron-right']
                    })
                ].join(''),
                attributes: {
                    href: '/settings#themeTab'
                }
            }));
        }
    });

    curations.Reports = RivalIQ.apps.Dashboard.models.Curation.extend({
        title: 'PPT / CSV Reports',
        widgetsView: WidgetsView,
        widgetDefinitions: widgets
    });
});
